/*importing fluxxor*/
var Fluxxor = require('fluxxor');
import { FluxMixin, StoreWatchMixin, flux } from './flux'

/*importing react and react-router*/
import React from 'react'
import { render } from 'react-dom'
import { Router,  useRouterHistory  } from 'react-router'
import { createHashHistory } from 'history';

/*importing routes*/
import routes from './components/routes';

// useRouterHistory creates a composable higher-order function
const appHistory = useRouterHistory(createHashHistory)({ queryKey: false });


class BlendedAdmin {
	
	constructor (platform_obj) {
		this.platform_obj =  platform_obj
	}

	start (divRef) {
		var _this =  this
		render(React.createElement(Router, { routes: routes, history: appHistory, createElement: this.createFluxComponent.bind(_this) }), divRef);
	}

	createFluxComponent (Component, props) {
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
        return  React.createElement(Component, _extends({}, props, { flux: flux, platform: this.platform_obj }));
    };

}


global.BlendedAdmin =  BlendedAdmin

/*
$(document).ready(function () {
	render(
	  <Router routes={routes} history={appHistory} createElement={createFluxComponent}/>,
	  document.getElementById('blendedux')
	);
});*/

// var hostUrl = (window.location.href).split("wp-admin")[0];
// hostUrl = hostUrl + "blended/v0";

/*var blended  =  new BlendedAdmin ({
	"css" : {
		"marginTop": "32px"
	},
	"style": "//stgcdn.blended.co/app/blended_v0.0.1-rc0380/App/Library/css/style_drupal.css",
	"hostUrl" : "http://52.20.249.96/hasan/blended/v0"
})
var divRef =  document.getElementById ('blendedux')
blended.start (divRef)*/


/** WEBPACK FOOTER **
 ** ./html/app.js
 **/